import type { FC } from "react";
import { ChatAttachmentFile } from "web_myplann/Chat/Components/Attachments/ChatAttachmentFile";
import { ChatAttachmentImage } from "web_myplann/Chat/Components/Attachments/ChatAttachmentImage";
import { getChatAttachmentKey } from "web_myplann/Chat/Helpers/Attachments/getChatAttachmentKey";
import type {
	ChatAttachmentFileStyle,
	ChatAttachmentView,
} from "web_myplann/Chat/Types/chatMessage";

type Props = {
	attachments: ChatAttachmentView[];
	fileStyle: ChatAttachmentFileStyle;
	isUploading?: boolean;
};

export const ChatMessageAttachments: FC<Props> = ({
	attachments,
	fileStyle,
	isUploading,
}) => (
	<>
		{attachments.map((attachment, index) =>
			attachment.isImage ? (
				<ChatAttachmentImage
					key={getChatAttachmentKey(attachment, index)}
					attachment={attachment}
					fileStyle={fileStyle}
					isUploading={isUploading}
				/>
			) : (
				<ChatAttachmentFile
					key={getChatAttachmentKey(attachment, index)}
					attachment={attachment}
					fileStyle={fileStyle}
					isUploading={isUploading}
				/>
			),
		)}
	</>
);
